/**
 * Entry point (S11, F4AI-17). Poradie importov je dôležité:
 *  1. fonty (self-hostované `@fontsource` — žiadny Google Fonts request,
 *     šablóna tm-603 ich ťahala z CDN, my ich distribujeme s bundle),
 *  2. `tokens.css` (design tokeny 1:1 z Nexaverse),
 *  3. `app.css` (layout shell postavený na tokenoch).
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import '@fontsource-variable/syne';
import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import './styles/tokens.css';
import './styles/app.css';

import { App } from './App.js';
import { IdentityProvider } from './nostr/IdentityContext.js';
import { applyTheme, readTheme } from './lib/theme.js';

// tému aplikujeme pred prvým renderom, aby sa neblinulo tmavou verziou
applyTheme(readTheme());

const container = document.getElementById('root');
if (container === null) {
  throw new Error('v index.html chýba element #root');
}

// `IdentityProvider` je nad `App`: Header ukazuje npub a Composer podpisuje
// — bez neho by `useIdentity()` vrátilo prázdnu identitu (test entry.test.tsx
// kontroluje práve toto, lebo testy renderujú Appku s providerom samy).
createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <IdentityProvider>
        <App />
      </IdentityProvider>
    </BrowserRouter>
  </StrictMode>,
);
